import { useEffect } from 'react'
import { enterFullscreen, fullscreenSupported, isFullscreen } from '@/game/fullscreen'

export function useAutoFullscreenOnPlay(enabled: boolean) {
  useEffect(() => {
    if (!enabled || !fullscreenSupported() || isFullscreen()) return
    void enterFullscreen()
    if (isFullscreen()) return
    const tryFullscreen = () => {
      void enterFullscreen()
      window.removeEventListener('pointerdown', tryFullscreen)
      window.removeEventListener('keydown', tryFullscreen)
    }
    window.addEventListener('pointerdown', tryFullscreen)
    window.addEventListener('keydown', tryFullscreen)
    return () => {
      window.removeEventListener('pointerdown', tryFullscreen)
      window.removeEventListener('keydown', tryFullscreen)
    }
  }, [enabled])
}
